export default "__VITE_ASSET__$MseJIqD__"